import React from 'react';
import { MapPin, MessageSquare, Phone } from 'lucide-react';
import { site } from '../data/site';
export function SiteFooter() {
  return <footer className="w-full bg-[#0B1B3A] py-14 text-white" data-id="element-70" data-mp="3r8rg8o0685xb">
      <div className="mx-auto grid w-full max-w-7xl gap-10 px-5 md:grid-cols-3 lg:px-10" data-id="element-71" data-mp="3mgrdknspuyx1">
        <div className="flex items-center gap-4" data-id="element-72" data-mp="3hiznlzbmtmvh">
          <img src={site.logo} alt="" className="h-16 w-16 object-contain" data-id="element-73" data-mp="3hi6cyn9jyd82" />
          <span className="font-heading text-2xl font-black uppercase leading-none tracking-tight" data-id="element-74" data-mp="3dhmdhd1iaxir">
            Rangel's
            <span className="block text-[0.55em] tracking-[0.25em] text-white/60" data-id="element-75" data-mp="38ggnhmz8docx">
              Painting
            </span>
          </span>
        </div>

        <div data-id="element-76" data-mp="2ykdlch4dpppz">
          <h2 className="font-heading text-sm font-black uppercase tracking-[0.2em] text-[#FACC15]" data-id="element-77" data-mp="2ykvozytdf67x">
            Contact
          </h2>
          <ul className="mt-4 space-y-3 text-white/80" data-id="element-78" data-mp="11p7lzjqwarbc">
            <li data-id="element-79" data-mp="wta9xpmo074d">
              <a href={site.phoneHref} className="flex items-center gap-3 hover:text-[#FACC15]" data-id="element-80" data-mp="wsqnbvm2kuk0">
                <Phone className="h-4 w-4" aria-hidden="true" data-id="element-81" data-mp="1aponmxw6cki0" />
                Call {site.contactName} · {site.phone}
              </a>
            </li>
            <li data-id="element-82" data-mp="vu8oiegqlyer">
              <a href={site.smsHref} className="flex items-center gap-3 hover:text-[#FACC15]" data-id="element-83" data-mp="vus8s1tv0yvy">
                <MessageSquare className="h-4 w-4" aria-hidden="true" data-id="element-84" data-mp="1ogthtkgrwkky" />
                Text {site.phone}
              </a>
            </li>
            <li className="flex items-center gap-3" data-id="element-85" data-mp="1tfwof9ceiyv1">
              <MapPin className="h-4 w-4" aria-hidden="true" data-id="element-86" data-mp="1es36vj3r9m9t" />
              {site.area}
            </li>
          </ul>
        </div>

        <div data-id="element-87" data-mp="1jpbpfkstfsbl">
          <h2 className="font-heading text-sm font-black uppercase tracking-[0.2em] text-[#FACC15]" data-id="element-88" data-mp="1jotls33tqbtn">
            Hours
          </h2>
          <ul className="mt-4 space-y-2 text-white/80" data-id="element-89" data-mp="2c6xjhmaeia9b">
            <li data-id="element-90" data-mp="2c8ic36d5nj4j">Mon – Fri · 7am – 7pm</li>
            <li data-id="element-91" data-mp="2m2xmtvi132a8">Saturday · 8am – 4pm</li>
            <li data-id="element-92" data-mp="2m1uwboomb1uu">Sunday · By appointment</li>
          </ul>
        </div>
      </div>

      <div className="mx-auto mt-12 w-full max-w-7xl border-t border-white/15 px-5 pt-6 text-sm text-white/50 lg:px-10" data-id="element-93" data-mp="2h3l2piijk9bc">
        © {new Date().getFullYear()} {site.name}. Free estimates · Quality work ·
        Friendly service.
      </div>
    </footer>;
}